<template>
  <div class="row mt-10">
    <div class="col-sm-12">
      <h4 class="text-primary">Order #{{order.orderID}}
        <span class="order-status">Status: {{order.orderstatus}}</span>
      </h4>
      <div class="shipment-detail" v-if="order.shipments.data && order.shipments.data.length">
        <h4 class="text-primary">Shipment Detail</h4>
        <order-shipment
                v-for="shipment in order.shipments.data"
                :key="shipment.shipmentID"
                :shipment="shipment">
        </order-shipment>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-12">
          <table id="cart-index-items" class="table table-condensed">
            <thead>
            <tr>
              <th class="th-text">item</th>
              <th class="th-text text-center text-nowrap">gift box</th>
              <th class="th-text text-center">qty</th>
              <th class="th-text text-right">price</th>
            </tr>
            </thead>
            <tbody
                v-for="orderItem in order.orderitems.data"
                :key="orderItem.orderitemID">
              <tr class="item-row">
                <td>
                  <order-item class="cart-item cart-item-small" :item="orderItem">
                    <div slot="description" class="mt-10">
                      <div v-if="orderItem.returns.length" class="item-returns">
                        Returned <span v-for="item in orderItem.returns" :key="item.date"><span v-if="item.qty != orderItem.qty"> {{item.qty}} of {{orderItem.qty}}</span> on {{item.date}} </span>
                      </div>
                      <strong v-else-if="orderItem.backorder_qty">Will ship {{ orderItem.restock_date_label }}</strong>
                      <div v-else-if="orderItem.is_product" class="text-center">
                        <em class="small hidden-xs hidden-ms">Share your purchase</em>
                        <share-all :url="orderItem.url" :image-url="orderItem.share_image_url" description="Look what I just bought at juliannarae.com"></share-all>
                      </div>
                    </div>
                  </order-item>
              </td>
              <td class="text-center">
                {{ orderItem.giftwrap_YN }}
              </td>
              <td class="text-center">
                {{ orderItem.qty || orderItem.backorder_qty }}
              </td>
              <td class="text-right">
                {{ orderItem.extended_priceCurrency }}<br>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-xs-12 col-ms-6 col-sm-5 pull-right">
          <order-totals :order="order"></order-totals>
        </div>

        <div class="col-xs-12 col-ms-6 col-sm-7 pull-right">
          <fieldset>
            <legend>Shipping Address</legend>
            <address-item style="font-size:larger;margin-bottom:0" :address="order.shipaddress">
              <p><strong>{{order.shipemail}}</strong></p>
            </address-item>
          </fieldset>
        </div>

        <div class="clearfix"></div>

        <div v-if="order.giftwrapcharge && order.giftwrapmessage" class="col-sm-12">
          <hr>
          <fieldset class="row-margin">
            <legend>Gift Message</legend>
            <pre style="white-space: pre-wrap; word-break: initial;">{{ order.giftwrapmessage }}</pre>
          </fieldset>
        </div>
      </div>
    </div>
    <div v-if="0" class="col-sm-12 pre-scrollable">
      <pre>
        {{ order }}
      </pre>
    </div>
  </div>
</template>

<style scoped>
h4 {
  margin: 0;
}
legend {
  font-size: 18px;
  margin-bottom: 10px;
}
table {
  margin-bottom: 10px;
}
.item-row {
  padding: 0 20px;
}
.item-row td {
  padding: 0;
}
.order-status {
  font-size: small;
  color: #000;
  font-weight: 700;
  font-style: italic;
  margin-left: 20px;
}
.item-returns {
  border: 2px solid #990033;
  border-radius: 5px;
  padding: 5px;
  font-weight: bold;
}
.shipment-detail, .return-detail {
  margin-top: 10px;
  border: 2px solid #990033;
  border-radius: 5px;
  padding: 5px;
}
.shipment-detail h4, .return-detail h4 {
  margin-bottom: 5px;
}
</style>

<script>
import AddressItem from './AddressItem'
import OrderItem from './../OrderItem'
import ShareAll from "../social/ShareAll"
import OrderTotals from './OrderTotals'
import OrderShipment from './OrderShipment'

export default {
    components: {
        'address-item': AddressItem,
        'order-item': OrderItem,
        'share-all': ShareAll,
        'order-totals': OrderTotals,
        'order-shipment': OrderShipment,
    },

    props: {
        order: {
            type: Object,
            default: null
        },
    },
}
</script>
